import React from 'react';

const workExperience = [
  {
    company: 'Capgemini Technology Services India Limited',
    role: 'Manager - Talent Management',
    duration: 'Jan 2026 - Present · 2 mos',
    responsibilities:
      'Driving strategic talent management and leadership development initiatives across pan-India locations. Leading enterprise-level talent development and leadership enablement programs, partnering with senior stakeholders to strengthen the leadership pipeline and accelerate business growth. Designing and implementing structured talent strategies that support leadership transitions, executive readiness, succession planning, and workforce capability development. Collaborating with global and regional teams to ensure effective program governance and organizational alignment. Contributing to a sustainable, high-impact talent ecosystem that enables long-term organizational success.',
    current: true,
  },
  {
    company: 'Tata Technologies',
    role: 'Sr. Lead & Manager - Talent Management, OD and Diversity',
    duration: 'May 2023 - Jan 2026 · 2 yrs 8 mos',
    responsibilities:
      'Led the People Operations and Human Resources function, driving both operational excellence and strategic workforce initiatives across departments and geographies. Spearheaded diversity, equity, and inclusion (DEI) programs aligned with organizational goals while optimizing HR processes and HRIS systems to enhance onboarding, reporting, and employee lifecycle management. Partnered with HR Business Partners and cross-functional leaders to deliver data-driven insights, strengthen DEI visibility, and support strategic decision-making that improved organizational effectiveness.',
    current: false,
  },
  {
    company: 'ŠKODA AUTO Volkswagen India Private Limited',
    role: 'Assistant Manager Human Resources',
    duration: 'Aug 2017 - May 2023 · 5 yrs 9 mos',
    responsibilities:
      'Led strategic Human Resources and Talent Management initiatives across PAN-India locations, driving leadership development, workforce planning, and organizational effectiveness for a 500+ employee workforce. Designed and implemented competency frameworks and high-potential development programs aligned with succession planning and business growth objectives. Delivered leadership development and behavioral training through blended learning models, including coaching, assessments, and e-learning solutions. Strengthened employee engagement, performance management, and talent assessment processes through data-driven insights and structured HR programs. Spearheaded diversity and inclusion initiatives, induction programs, and cross-regional communication forums to enhance culture and leadership readiness. Managed end-to-end HR operations, recruitment strategies, campus hiring, and large-scale training interventions to build a high-performing, future-ready workforce.',
    current: false,
  },
  {
    company: 'Sanjeev Auto Parts Manufacturers Pvt. Ltd.',
    role: 'HR Specialist',
    duration: 'Jun 2015 - Aug 2017 · 2 yrs 3 mos',
    responsibilities:
      'Managed strategic HR projects focused on improving employee relations and retention. Conducted employee satisfaction surveys and engagement activities, implemented HR systems, and handled performance management and HRIS to foster a positive work environment.',
    current: false,
  },
  {
    company: 'Siemens',
    role: 'Management Trainee',
    duration: 'Jun 2014 - Jul 2014 · 2 mos',
    responsibilities:
      'Analyzed industrial relations records, contributed to the Organizational Health Center Department, and led employee engagement initiatives. Assisted in policy implementation and coordinated CSR activities while supporting HR efforts in improving organizational well-being.',
    current: false,
  },
  {
    company: 'Lotus Business Management & Consultancy Ltd',
    role: 'Admin Coordinator in Marketing Training',
    duration: 'Jul 2013 - Sep 2013 · 3 mos',
    responsibilities:
      'Handled telemarketing efforts targeted at HR professionals for business trainings in the Aurangabad region. Focused on improving interpersonal skills and effective communication.',
    current: false,
  },
];

export default function Timeline() {
  return (
    <div className='bg-white py-16 sm:py-16' data-testid='timeline-component'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-xl text-center'>
          <p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
            Professional Journey
          </p>
        </div>
        <ol className='relative border-s border-gray-200 mt-16'>
          {workExperience.map((experience) => (
            <li className='mb-10 ms-6' key={experience.role}>
              <span className='absolute flex items-center justify-center w-6 h-6 bg-gray-100 rounded-full -start-3 ring-8 ring-white'>
                <svg
                  className='w-2.5 h-2.5 text-gray-500'
                  aria-hidden='true'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                >
                  <path d='M19.728 10.686c-2.38 2.256-6.153 3.381-9.875 3.381-3.722 0-7.4-1.126-9.571-3.371L0 10.437V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7.6l-.272.286Z' />
                  <path d='m.135 7.847 1.542 1.417c3.6 3.712 12.747 3.7 16.635.01L19.605 7.9A.98.98 0 0 1 20 7.652V6a2 2 0 0 0-2-2h-3V3a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v1H2a2 2 0 0 0-2 2v1.765c.047.024.092.051.135.082ZM10 10.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM7 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H7V3Z' />
                </svg>
              </span>
              <h3 className='flex items-center mb-1 text-lg font-semibold text-gray-900'>
                {experience.company}
                {experience.current && (
                  <span className='bg-gray-100 text-blue-600 text-sm font-medium me-2 px-2.5 py-0.5 rounded  ms-3'>
                    Current
                  </span>
                )}
              </h3>
              <time className='block mb-2 text-sm font-normal leading-none text-green-600 '>
                {experience.role}
              </time>
              <time className='block mb-2 text-sm font-normal leading-none text-gray-400 '>
                {experience.duration}
              </time>
              <p className='mb-4 text-base font-normal text-gray-500 '>
                {experience.responsibilities}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
